import { ClientWebPage } from '@common/model/meta/clientWebPage';
import type { RoutesDictionaryEntry } from './types';

export const CITY_PATH_PARAMETER = 'city';

export const STATIC_CLIENT_WEB_ROUTES: RoutesDictionaryEntry[] = [
  { path: '/offline/', pageId: ClientWebPage.Offline, exact: true },
  { path: '/impersonate/', pageId: ClientWebPage.Impersonation, exact: true },
  { path: '/about-us/', pageId: ClientWebPage.AboutUs, exact: true },
  { path: '/faq/', pageId: ClientWebPage.FAQ, exact: true },
  { path: '/contacts/', pageId: ClientWebPage.Contacts, exact: true },
  { path: '/support/', pageId: ClientWebPage.Support, exact: true },
  { path: '/legal-information/', pageId: ClientWebPage.LegalInformation, exact: true },
  { path: '/user-agreement/', pageId: ClientWebPage.UserAgreement, exact: true },
  { path: '/privacy-policy/', pageId: ClientWebPage.PrivacyPolicy, exact: true },
  { path: '/payment-policy/', pageId: ClientWebPage.PaymentAndRefund, exact: true },
];
